// axios
import router from '@/router'
import axios from 'axios'
import Vue from 'vue'

const LEGACY_API_DOMAIN = 'backaws.motocasystems.com.br'
const CURRENT_API_DOMAIN = 'back.motocasystems.com.br'
const DEFAULT_API_BASE_URL = 'https://back.motocasystems.com.br'

const resolveApiBaseUrl = () => {
  const envUrl = process.env.VUE_APP_AXIOS_FILE_URL || process.env.VUE_APP_AXIOS_URL

  if (!envUrl) return DEFAULT_API_BASE_URL

  return envUrl.replace(LEGACY_API_DOMAIN, CURRENT_API_DOMAIN)
}

const axiosFileApi = axios.create({
  // You can add your headers here
  // ================================

  baseURL: resolveApiBaseUrl(),

  // timeout: 1000,
  // headers: {'X-Custom-Header': 'foobar'}
})

axiosFileApi.interceptors.request.use(
  config => {
    // Do something before request is sent

    const accessToken = localStorage.getItem('accessToken')

    // eslint-disable-next-line no-param-reassign
    if (accessToken) config.headers.Authorization = `Bearer ${accessToken}`

    return config
  },
  error => Promise.reject(new Error(error)),
)

axiosFileApi.interceptors.response.use(
  response => response,
  error => {
    // console.log('axios: ', error.response.data.data.message)

    // console.log('axios: ', error.message)

    if (error?.response && error?.response?.status === 401) {
      if (router.currentRoute.path !== '/login') {
        router.push('/login')
      }
    }

    // console.log(error.response)

    return Promise.reject(new Error(error.response.data.message ?? error.message))
  },
)

Vue.prototype.$http = axiosFileApi

export default axiosFileApi
